import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc2005',
    ecrans: [ '00-2']
});

